import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ReactComponent as LightLogo } from "../../assets/images/logo/logo-light.svg";
import { ReactComponent as LightPremiumLogo } from "../../assets/images/logo/logo-light-premium.svg";

import "./Logo.sass";

function Logo({ userData }) {
  return (
    <section className="logo">
      <Link to="/">
        {userData && userData?.profile_type?.toLowerCase() === "premium" ? (
          <LightPremiumLogo
            style={{ width: 24, height: 24 }}
            className="logo__icon"
          />
        ) : (
          <LightLogo style={{ width: 24, height: 24 }} className="logo__icon" />
        )}

        <h3 className="logo__text">PC APP STORE™</h3>
      </Link>
    </section>
  );
}

Logo.propTypes = {
  userData: PropTypes.objectOf(PropTypes.string),
};
Logo.defaultProps = {
  userData: null,
};

const mapStateToProps = (state) => ({
  userData: state.userDataStore.userData,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Logo);
